module.exports = __webpack_public_path__ + "static/img/login-bg.e213405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.jpg
// module id = kDKx
// module chunks = 489